import { default as React } from 'react';

export const ThemeContext = React.createContext({
    open: false,
    setOpen: (value: boolean) => {
        // default value
    }
});